module.exports = __webpack_public_path__ + "img/Entia-Infraestructura-Ferroviaria-1.e33db7b7.webp";